import { render, staticRenderFns } from "./LocalPaymentsAddPayeeSuccess.vue?vue&type=template&id=1bbd4f1e"
import script from "./LocalPaymentsAddPayeeSuccess.vue?vue&type=script&lang=js"
export * from "./LocalPaymentsAddPayeeSuccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports